module.exports = __webpack_public_path__ + "img/IAA-image-2.d9fd219f.png";